module.exports = __webpack_public_path__ + "img/jgjgbg.180314d5.png";